import "./App.scss";
import TheRoutes from "layout/TheRoutes";
import React from "react";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { ToastContainer } from "react-toastify";
import BrowserGuard from "auth/BrowserGuard";
import AudioProvider from "components/AudioProvider";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

initializeApp(firebaseConfig);
if (process.env.NODE_ENV !== "development") {
  console.log = () => {};
}
const App = () => {
  return (
    <>
      <BrowserGuard>
      <AudioProvider>
        <TheRoutes />
        </AudioProvider>
      </BrowserGuard>
    </>
  );
};

export default App;
